import React from "react";
import { CardContent, Typography } from "@material-ui/core";
import { Spacer } from "@internal/plugin-utilities";
import { Divider } from "@material-ui/core";
import { OpsReviewEditForm } from "../OpsReviewEditForm";
import { Layout } from "./Layout";
import { getOpsreviewDayOfWeek } from "@internal/plugin-ops-review-common";
import { TeamCarousel } from "../../components/TeamBreakdown";
import { IssuesAndRecommendationsSection } from "../../components/IssuesAndRecommendationsSection";
import { SLOSection } from "../../components/SLOSection";
import { WinsSection } from "../../components/WinsSection";
import { FreeformSection } from "../../components/FreeformSection";
import { OwnershipSection } from "../../components/OwnershipSection";
import { Progress } from "@backstage/core-components";
import { useHistoricalReference } from "../../hooks/useHistoricalReference";
import moment from "moment";
import { JiraIssuesSection } from "../../components/JiraIssuesSection";

export interface Props {}

export const Divide: React.FC<{}> = (): JSX.Element => {
  return (
    <>
      <Spacer variant="double" />
      <Divider />
      <Spacer variant="double" />
    </>
  );
};

export const Wrapper = ({
  date,
  children,
}: {
  date: string;
  children: React.ReactNode;
}) => {
  return (
    <Layout>
      <Layout.Route path="/view" title={`OpsReview ${date}`}>
        <CardContent>
          <Typography variant="h1" style={{ textAlign: "center" }}>
            OpsReview {date}
          </Typography>
          {children}
        </CardContent>
      </Layout.Route>
      <Layout.Route path="/edit" title="Edit">
        <OpsReviewEditForm />
      </Layout.Route>
      {/* @TODO: Hasn't worked right in awhile, leaving off for now */}
      {/* <Layout.Route path="/archive" title="Archived">
        <OpsReviewArchive />
      </Layout.Route> */}
    </Layout>
  );
};

export const OpsReviewPage: React.FC<Props> = (): JSX.Element => {
  const printRef = React.useRef<HTMLInputElement>(null);
  const date = getOpsreviewDayOfWeek();
  const passedDate = date.format("YYYY-MM-DD");
  const displayDate = date.format("MM-DD-YYYY");
  const opsReviewData = useHistoricalReference({ date: passedDate });
  const snapshotDate = opsReviewData.value && opsReviewData.value.updated_at;
  const history = opsReviewData.value && opsReviewData.value.history;

  if (
    opsReviewData.error ||
    (opsReviewData.value && opsReviewData.value.error)
  ) {
    return (
      <Wrapper date={displayDate}>
        <Typography style={{ textAlign: "center" }}>
          {opsReviewData.error
            ? opsReviewData.error.message
            : opsReviewData.value.message}
        </Typography>
      </Wrapper>
    );
  }

  const progress = <Progress />;

  const opsReviewSections = (
    <>
      <WinsSection
        wins={history?.weeklyDetails?.wins}
        loading={opsReviewData.loading}
        key="wins"
      />
      <Divide key="wins-divide" />
      <SLOSection
        key="slos"
        companySloData={history?.companySlos}
        loading={opsReviewData.loading}
      />
      <Divide key="slos-divide" />
      <JiraIssuesSection
        key="jira"
        loading={opsReviewData.loading}
        data={history?.jiraIssues || []}
      />
      <Divide key="jira-divide" />
      <TeamCarousel
        key="team-carousel"
        teamBreakdownData={history?.teamViolationData}
        loading={opsReviewData.loading}
      />
      <Divide key="team-carousel-divide" />
      <OwnershipSection
        key="ownership"
        data={history?.ownership}
        loading={opsReviewData.loading}
      />
      <Divide key="ownership-divide" />
      <IssuesAndRecommendationsSection
        data={history?.weeklyDetails?.issuesAndRecommendations}
        loading={opsReviewData.loading}
        key="issues-and-recommendations"
      />
      <Divide key="issues-and-recommendations-divide" />
      <FreeformSection
        data={history?.weeklyDetails?.freeform}
        key="freeform"
        loading={opsReviewData.loading}
      />
    </>
  );

  const cardContent = (
    <CardContent id="ops-review-content" ref={printRef}>
      <Typography variant="subtitle1" style={{ textAlign: "center" }}>
        Snapshot timestamp: {moment(snapshotDate).format("MM-DD-YYYY @ HH:mm")}
      </Typography>
      {opsReviewData.loading ? progress : opsReviewSections}
    </CardContent>
  );

  return <Wrapper date={displayDate}>{cardContent}</Wrapper>;
};
